export enum ShipmentFrameUrlParam {
  LOCALE = 'locale',
  TOKEN = 'token',
  SOURCE = 'source'
}

export const ClaimLocale = 'uk';

export const ClaimSource = 'external-bc-ua';

export const ShipmentFrameCookiePrefix = 'Bearer';
